import React, { ComponentClass, PureComponent, ReactNode } from "react";
import { Mutation } from "react-apollo";

import { IProduct } from "../../../types/product";
import { IUser } from "../../../types/user";
import { getMeFromCache } from "../../services/me";

import UserWishRemoveMutation from "./graphql/UserWishRemove";

export interface IUserWishRemoveProps {
  userWishRemove: (product: IProduct) => Promise<IUser>;
}

export default <P extends object>(
  Component: React.ComponentType<P>
): ComponentClass<P> =>
  class UserWishRemove extends PureComponent<P> {
    public render(): ReactNode {
      return (
        <Mutation mutation={UserWishRemoveMutation}>
          {(
            userWishRemove: (params: {
              optimisticResponse: object;
              variables: {
                input: { id: string };
              };
            }) => void
          ): JSX.Element => {
            return (
              <Component
                {...this.props}
                userWishRemove={(product: IProduct): void => {
                  const user = getMeFromCache();
                  let optimisticResponse = {};
                  if (user) {
                    const newUser = {
                      ...user,
                      wishList: user.wishList.filter(
                        (userProduct: string): boolean =>
                          userProduct !== product.id
                      ),
                    };
                    optimisticResponse = {
                      __typename: "Mutation",
                      userWishRemove: {
                        __typename: "User",
                        ...newUser,
                      },
                    };
                  }

                  return userWishRemove({
                    optimisticResponse,
                    variables: {
                      input: {
                        id: product.id,
                      },
                    },
                  });
                }}
              />
            );
          }}
        </Mutation>
      );
    }
  };
